import { InvoiceActions, OrderRemainingHoursReportActions } from '../constants';
import { QueryParams } from 'src/types/grid';
import { InvoiceFormData } from 'src/screens/General/screens/Invoices/components/InvoiceForm';
import { Dispatch } from 'redux';
import { SagaPromise } from './auth-actions';
import { GetOrderRemainingHoursReportsAction } from './orderRemainingHoursReport-actions';
import { successType } from '../../services/api-handlers/api-resolver';

export interface GetInvoicesAction {
    type: typeof InvoiceActions.FETCH_INVOICES;
    payload: any;
    all?: any;
}

export function getInvoices(params: any): GetInvoicesAction {
    return {
        type: InvoiceActions.FETCH_INVOICES,
        payload: params,
    };
}

export interface GetInvoicesSmallAction {
    type: typeof InvoiceActions.FETCH_INVOICES_SIMPLY;
    payload: any;
    all?: any;
}

export function getInvoicesSmall(params: any): GetInvoicesSmallAction {
    return {
        type: InvoiceActions.FETCH_INVOICES_SIMPLY,
        payload: params,
    };
}

export interface GetInvoicesDocsAction {
    type: typeof InvoiceActions.FETCH_INVOICE_DOCS;
    payload: QueryParams;
    all?: any;
}

export function clearTotal(): any {
    return {
        type: successType(InvoiceActions.FETCH_INVOICES_TOTALS),
        payload: {},
        total: true,
    };
}

export function getInvoicesTotal(params: any): GetInvoicesAction {
    return {
        type: InvoiceActions.FETCH_INVOICES_TOTALS,
        payload: params,
    };
}

export function getInvoiceDocs(params: QueryParams): GetInvoicesDocsAction {
    return {
        type: InvoiceActions.FETCH_INVOICE_DOCS,
        payload: params,
    };
}

export interface DeleteInvoiceDocsAction {
    type: typeof InvoiceActions.DECLINE_INVOICE_DOCS;
    payload: {
        id: number | string;
        data: { isApprove: boolean };
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function deleteInvoiceDocs(
    id: number | string,
    data: { isApprove: boolean },
    onSuccess?: () => void,
    onError?: (error: string) => void,
): DeleteInvoiceDocsAction {
    return {
        type: InvoiceActions.DECLINE_INVOICE_DOCS,
        payload: { id, data, onSuccess, onError },
    };
}

export interface ApproveInvoiceDocsAction {
    type: typeof InvoiceActions.APPROVE_INVOICE_DOCS;
    payload: {
        id: number | string;
        data: { isApprove: boolean };
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function approveInvoiceDocs(
    id: number | string,
    data: { isApprove: boolean },
    onSuccess?: () => void,
    onError?: (error: string) => void,
): ApproveInvoiceDocsAction {
    return {
        type: InvoiceActions.APPROVE_INVOICE_DOCS,
        payload: { id, data, onSuccess, onError },
    };
}

interface QueryParamsAll extends QueryParams {
    all?: any;
}
export function getInvoicesCsv(params: QueryParamsAll): GetInvoicesAction {
    return {
        type: InvoiceActions.FETCH_INVOICES_CSV,
        payload: params,
        all: params.all,
    };
}

export interface GetInvoiceAction {
    type: typeof InvoiceActions.FETCH_INVOICE;
    payload: {
        id: string | number;
    };
}

export function getInvoice(id: string | number): GetInvoiceAction {
    return {
        type: InvoiceActions.FETCH_INVOICE,
        payload: { id },
    };
}

export interface CreateInvoiceAction {
    type: typeof InvoiceActions.CREATE_INVOICE;
    payload: {
        data: any;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function createInvoice(
    data: any,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): CreateInvoiceAction {
    return {
        type: InvoiceActions.CREATE_INVOICE,
        payload: { data, onSuccess, onError },
    };
}

export interface SignInvoiceDocAction {
    type: typeof InvoiceActions.SIGN_INVOICE_DOC;
    payload: {
        id: any;
        files: any;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function signInvoiceDoc(
    id: any,
    files: any,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): SignInvoiceDocAction {
    return {
        type: InvoiceActions.SIGN_INVOICE_DOC,
        payload: { id, files, onSuccess, onError },
    };
}

export interface DeleteInvoiceAction {
    type: typeof InvoiceActions.DELETE_INVOICE;
    payload: {
        id: number | string;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function deleteInvoice(
    id: number | string,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): DeleteInvoiceAction {
    return {
        type: InvoiceActions.DELETE_INVOICE,
        payload: { id, onSuccess, onError },
    };
}

export interface NotifySignerOnInvoiceAction {
    type: typeof InvoiceActions.NOTIFY_SIGNER_ON_INVOICE;
    payload: {
        data: InvoiceFormData;
        callbacks: SagaPromise<any>;
    };
}

export function notifySignerOnInvoice(data: InvoiceFormData, callbacks: SagaPromise<any>): NotifySignerOnInvoiceAction {
    return {
        type: InvoiceActions.NOTIFY_SIGNER_ON_INVOICE,
        payload: {
            data,
            callbacks,
        },
    };
}

export interface SendInvoiceToDocusignAction {
    type: typeof InvoiceActions.SEND_INVOICE_TO_DOCUSIGN;
    payload: {
        data: InvoiceFormData;
        callbacks: SagaPromise<any>;
    };
}

export function sendToDocusign(data: InvoiceFormData, callbacks: SagaPromise<any>): SendInvoiceToDocusignAction {
    return {
        type: InvoiceActions.SEND_INVOICE_TO_DOCUSIGN,
        payload: {
            data,
            callbacks,
        },
    };
}

export interface SendInvoiceToParentAction {
    type: typeof InvoiceActions.SEND_INVOICE_TO_PARENT;
    payload: {
        data: InvoiceFormData;
        callbacks: SagaPromise<any>;
    };
}

export function sendToParent(data: InvoiceFormData, callbacks: SagaPromise<any>): SendInvoiceToParentAction {
    return {
        type: InvoiceActions.SEND_INVOICE_TO_PARENT,
        payload: {
            data,
            callbacks,
        },
    };
}


export interface SaveInvoiceReasonAction {
    type: typeof InvoiceActions.SAVE_INVOICE_REASON;
    payload: {
        data: InvoiceFormData;
        callbacks: SagaPromise<any>;
    };
}

export function saveInvoiceReason(data: InvoiceFormData, callbacks: SagaPromise<any>): SaveInvoiceReasonAction {
    return {
        type: InvoiceActions.SAVE_INVOICE_REASON,
        payload: {
            data,
            callbacks,
        },
    };
}

export interface SaveInvoiceNoteAction {
    type: typeof InvoiceActions.SAVE_INVOICE_NOTE;
    payload: {
        data: InvoiceFormData;
        callbacks: SagaPromise<any>;
    };
}

export function saveInvoiceNote(data: InvoiceFormData, callbacks: SagaPromise<any>): SaveInvoiceNoteAction {
    return {
        type: InvoiceActions.SAVE_INVOICE_NOTE,
        payload: {
            data,
            callbacks,
        },
    };
}

export interface SendStatementToParentAction {
    type: typeof InvoiceActions.SEND_STATEMENT_TO_PARENT;
    payload: {
        data: InvoiceFormData;
        callbacks: SagaPromise<any>;
    };
}

export function sendStatementToParent(data: InvoiceFormData, callbacks: SagaPromise<any>): SendStatementToParentAction {
    return {
        type: InvoiceActions.SEND_STATEMENT_TO_PARENT,
        payload: {
            data,
            callbacks,
        },
    };
}

export interface PersistInvoiceAction {
    type: typeof InvoiceActions.PERSIST_INVOICE;
    payload: {
        data: InvoiceFormData;
        files: any;
        callbacks: SagaPromise<any>;
    };
}

export function persistInvoice(data: InvoiceFormData, files: any, callbacks: SagaPromise<any>): PersistInvoiceAction {
    return {
        type: InvoiceActions.PERSIST_INVOICE,
        payload: {
            data,
            files,
            callbacks,
        },
    };
}

export const asyncPersistInvoice = (data: InvoiceFormData, files: any, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(persistInvoice(data, files, { resolve, reject }));
    });
};

export const asyncCreateFilesInvoice = (id: number | string, files: any, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(createFilesInvoice(id, files, { resolve, reject }));
    });
};

export interface CreateFilesInvoiceAction {
    type: typeof InvoiceActions.CREATE_FILES_INVOICE;
    payload: {
        id: number | string;
        files: any;
        callbacks: SagaPromise<any>;
    };
}

export function createFilesInvoice(
    id: number | string,
    files: any,
    callbacks: SagaPromise<any>,
): CreateFilesInvoiceAction {
    return {
        type: InvoiceActions.CREATE_FILES_INVOICE,
        payload: {
            id,
            files,
            callbacks,
        },
    };
}

export interface GetFilesAction {
    type: typeof InvoiceActions.FETCH_FILES_INVOICE;
    payload: {
        id: string | number;
    };
}

export function getFiles(id: string | number): GetFilesAction {
    return {
        type: InvoiceActions.FETCH_FILES_INVOICE,
        payload: { id },
    };
}

export interface GetSignersAction {
    type: typeof InvoiceActions.FETCH_SIGNERS_INVOICE;
    payload: {
        id: string | number;
    };
}

export function getSigners(id: string | number): GetSignersAction {
    return {
        type: InvoiceActions.FETCH_SIGNERS_INVOICE,
        payload: { id },
    };
}

export interface DeleteFileInvoiceAction {
    type: typeof InvoiceActions.DELETE_FILE_INVOICE;
    payload: {
        id: number | string;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function deleteFileInvoice(
    id: number | string,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): DeleteFileInvoiceAction {
    return {
        type: InvoiceActions.DELETE_FILE_INVOICE,
        payload: { id, onSuccess, onError },
    };
}

export type Actions =
    | GetInvoicesAction
    | GetInvoicesSmallAction
    | GetInvoicesDocsAction
    | SignInvoiceDocAction
    | GetInvoiceAction
    | DeleteInvoiceAction
    | PersistInvoiceAction
    | NotifySignerOnInvoiceAction
    | SendInvoiceToDocusignAction
    | SendInvoiceToParentAction
    | SaveInvoiceReasonAction
    | SaveInvoiceNoteAction
    | SendStatementToParentAction
    | ApproveInvoiceDocsAction
    | CreateInvoiceAction
    | DeleteInvoiceDocsAction;
